import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/reconditioner-centers/:reconditionerCenterId',
    name: 'reconditionerCenterDetail',
    component: () =>
      import(
        '@/views/restricted/recycling-module/reconditioner/reconditioner-center/ReconditionerCenterDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_READ'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/reconditioners/:reconditionerId/centers/create',
    name: 'reconditionerCenterCreate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/reconditioner/reconditioner-center/ReconditionerCenterCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_CREATE'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/reconditioner-centers/:reconditionerCenterId/edit',
    name: 'reconditionerCenterUpdate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/reconditioner/reconditioner-center/ReconditionerCenterUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_UPDATE'],
      menuSelected: 'recycling'
    }
  }
]
